import React, { useState } from "react";
import {
  Switch,
  Badge,
  Box,
  HStack,
  Text,
  Divider,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  List,
  ListItem,
} from "@chakra-ui/react";

interface Props {
  scopeId: string;
  onSwitchChange: (id: string, value: boolean) => void;
  isRequired: boolean;
  title: string;
  whyWeNeedIt: string;
  dataList: string[];
}

export const DataRequestScope = ({
  scopeId,
  onSwitchChange,
  isRequired,
  title,
  whyWeNeedIt,
  dataList,
}: Props) => {
  const [isSelected, setIsSelected] = useState(false);
  const colId = scopeId;
  const accoridanId = "accordian" + scopeId;
  const cardHeaderId = "heading" + scopeId;
  const buttonId = "btn" + scopeId;
  const collapseId = "collapse" + scopeId;
  const collapseTarget = "#" + collapseId;
  const collapsedataParent = "#" + accoridanId;

  const handleSwitchChange = () => {
    setIsSelected(!isSelected);
    onSwitchChange(scopeId, !isSelected);
  };

  return (
    <Box mb={5} borderRadius="md" borderColor="gray.200" borderWidth={1} p={4}>
      <HStack>
        <Box flex={1}>
          <Text id={colId} fontWeight="bold" fontSize="md">
            {title}
          </Text>
        </Box>

        <HStack spacing={3}>
          {isRequired && (
            <Box>
              <Badge colorScheme="red">Required</Badge>
            </Box>
          )}

          <Switch
            aria-label={`switch ${scopeId}`}
            aria-labelledby={colId}
            size="lg"
            checked={isSelected}
            onChange={handleSwitchChange}
          />
        </HStack>
      </HStack>
      <Divider mt={5} mb={3} />
      <Box mb={3}>
        <Text fontSize="sm" fontWeight="bold">
          Why we need it
        </Text>
        <Text fontSize="sm">{whyWeNeedIt}</Text>
      </Box>
      <Accordion
        id={accoridanId}
        allowToggle
        borderRadius="md"
        borderColor="gray.200"
        borderWidth={1}
      >
        <AccordionItem borderTop="none" id={cardHeaderId}>
          <AccordionButton
            bg="gray.50"
            id={buttonId}
            data-target={collapseTarget}
          >
            <Box flex="1" textAlign="left">
              <Text color="blue.500" fontSize="sm">
                Show full list
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>

          <AccordionPanel
            pb={4}
            data-parent={collapsedataParent}
            id={collapseId}
            aria-labelledby={cardHeaderId}
          >
            <List spacing={1} mt={3}>
              {dataList.map((item, i) => (
                <ListItem key={i}>{item}</ListItem>
              ))}
            </List>
          </AccordionPanel>
        </AccordionItem>
      </Accordion>
    </Box>
  );
};
